<script>
import {
  CurrentSubscriptionElementMixin,
} from "%/dynamic-component-editor/standard-components/current-subscription/current-subscription-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "CurrentSubscriptionStatus",
  elementPanelSettings: {
    displayName: "Current Subscription Status",
    displayIcon: "text-alt",
    elementGroup: "currentSubscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [CurrentSubscriptionElementMixin],
  computed: {
    value() {
      return this.currentSubscription.status ?? "";
    },
  },
};
</script>
